import { useEffect, useState } from "react";
import { api } from "./api";

let _market = null;
let _countries = null;

// Detect market once (.in -> India/INR, .com -> Global/USD) and cache it.
export function useMarket() {
  const [market, setMarket] = useState(_market);
  const [countries, setCountries] = useState(_countries || []);

  useEffect(() => {
    const override = new URLSearchParams(window.location.search).get("market");
    if (!_market || override) {
      api.get("/public/market", { params: override ? { market: override } : {} })
        .then(({ data }) => { _market = data; setMarket(data); })
        .catch(() => {});
    }
    if (!_countries) {
      api.get("/public/master/countries")
        .then(({ data }) => { _countries = data; setCountries(data); })
        .catch(() => {});
    }
  }, []);

  return { market, countries };
}

export function priceLabel(market, programType, track) {
  const p = market?.pricing?.[programType];
  if (!p) return track === "india" ? "₹499" : "$9";
  return track === "india" ? `₹${p.inr}` : `$${p.usd}`;
}
